import Model from '../models/model'

const model = new Model({
	name: 'EndoSetupHookup',
	allowImport: false,
	disableDelete: true,
	disableAdd: true,
	readOnly: true,
	title: 'EndoSetupHookup',
	idProperty: '_id',
	formTitleField: 'Scopes',
	pageSize: 5,
	disableExport: false,
	showGridRefreshBtn: true,
	gridRefreshInterval: 150000, //Long polling ms
	disableExportCSV: false,
	defaultSort: 'MachineModel ASC',
	filter: [{ "operator": "$eq", "property": "IsDeleted", "value": false }],
	columns: [
		{ header: 'EquipmentModel', field: 'MachineModel', width: 150 },
		{ header: 'ScopeModel', field: 'ScopeModel', width: 150 },
		{ header: 'Channels', field: 'Channels', width: 140, align: 'right', headerAlign: 'right' },
		{ header: 'LeakTestChannels', field: 'ChannelsLeakTest', width: 150, align: 'right', headerAlign: 'right', type: 'number' },
		{ header: 'HookupBlock', field: 'HookupValue', width: 120 }
	]
});

export const EndoHookupModel = model;
export default model.createFormBase();